(() => {
  if (window.LimitlessHeroMedia) { window.LimitlessHeroMedia.init(document); return; }
  const controllers = new Map(), pagePlans = new Map();
  const shuffle = values => {
    const copy = [...values];
    for (let i = copy.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
  };
  const readPrevious = key => {
    try { return JSON.parse(sessionStorage.getItem(key)) || {}; } catch { return {}; }
  };
  const remember = (key, plan) => {
    try { sessionStorage.setItem(key, JSON.stringify({video:plan.video, images:plan.images})); } catch {}
  };
  const validURL = value => {
    if (typeof value !== 'string' || !value || /[<>]/.test(value)) return false;
    try { return ['http:', 'https:'].includes(new URL(value, document.baseURI).protocol); } catch { return false; }
  };
  const unique = (values, kind) => {
    const ids = new Set(), sources = new Set();
    return (Array.isArray(values) ? values : []).filter(item => {
      if (!item || typeof item !== 'object') return false;
      const source = kind === 'video' ? item.video : item.image;
      if (!item || typeof item.id !== 'string' || !item.title || !item.alt || !validURL(source) || !validURL(item.caseLink) || !(item.width > 0 && item.height > 0) || ids.has(item.id) || sources.has(source)) return false;
      if (kind === 'video' && !validURL(item.poster)) return false;
      ids.add(item.id); sources.add(source); return true;
    });
  };
  const prepare = root => {
    if (controllers.has(root)) return;
    const film = root.querySelector('[data-ll-hero-film]'), video = film?.querySelector('video');
    const poster = film?.querySelector('.ll-video-poster'), button = film?.querySelector('[data-ll-video-play]');
    const fallback = film?.querySelector('.ll-video-fallback'), slots = [...root.querySelectorAll('[data-ll-hero-image]')];
    let data;
    try { data = JSON.parse(root.querySelector('[data-ll-hero-media-data]').textContent); } catch { return; }
    if (!video || !poster || slots.length !== 4 || slots.some(slot => !slot.querySelector('img'))) return;
    if (!data || typeof data !== 'object') return;
    const projects = window.LimitlessHomeProjects;
    const allVideos = unique(data.videos, 'video'), allImages = unique(data.images, 'image');
    const images = projects ? projects.heroPool(allImages, 'image') : allImages;
    const videos = (projects ? projects.heroPool(allVideos, 'video') : allVideos).filter(item => item.id !== root.dataset.llHeroAvoidProject && images.filter(image => image.id !== item.id).length >= 4);
    if (!videos.length || images.length < 4) return;
    const key = 'll:hero:last:v1:' + (root.dataset.llHeroMediaKey || 'home');
    const previous = readPrevious(key), old = pagePlans.get(key);
    const choices = videos.filter(item => item.id !== previous.video);
    const availableVideos = choices.length ? choices : videos;
    const retainedImages = new Set((old?.images || []).filter(id => images.some(item => item.id === id)));
    const nonconflicting = availableVideos.filter(item => !retainedImages.has(item.id));
    // Owner 2026-10-10: a visitor's first homepage view keeps the server-rendered default film (its poster is the LCP image in the
    // initial HTML); later views and visits are random. The flag is set on that first view.
    // r6 2026-10-11 (owner): data.opening pins the five highest-quality films as the opening set on every load (centre film +
    // four side cards, server-rendered in limitless-hero.liquid so the first paint is already right). Random rotation from the
    // rest of the pool happens afterwards, in limitless-hero-collage.js.
    const openingIds = Array.isArray(data.opening) ? data.opening : [];
    const opening = openingIds.length === 5 ? openingIds.map(id => allVideos.find(item => item.id === id)) : [];
    const pinned = opening.length === 5 && opening.every(Boolean) && root.dataset.llHeroAvoidProject !== opening[0].id &&
      (!video.hasAttribute('src') || video.dataset.llVideoSrc === opening[0].video) ? opening : null;
    const slotItems = pinned ? pinned.slice(1).map(item => ({...item, image: item.poster, kind: 'video'})) : null;
    let firstView = false;
    try { firstView = !localStorage.getItem('ll:hero:seen:v1'); localStorage.setItem('ll:hero:seen:v1', '1'); } catch {}
    const serverDefault = firstView && !old ? videos.find(item => item.video === video.dataset.llVideoSrc) : null;
    const chosen = (pinned && pinned[0]) || serverDefault || videos.find(item => item.id === old?.video) || shuffle(nonconflicting.length ? nonconflicting : availableVideos)[0];
    const pictures = shuffle(images.filter(item => item.id !== chosen.id));
    const occupied = new Set();
    const chosenImages = Array.from({length:4}, (_, index) => {
      const id = old?.images[index];
      if (id && pictures.some(item => item.id === id) && !occupied.has(id)) {
        occupied.add(id); return id;
      }
      return null;
    });
    for (let i = 0; i < 4; i++) {
      if (chosenImages[i]) continue;
      const available = pictures.filter(item => !occupied.has(item.id));
      const next = available.find(item => item.id !== previous.images?.[i]) || available[0];
      chosenImages[i] = next.id; occupied.add(next.id);
    }
    const plan = {video:chosen.id, images: pinned ? pinned.slice(1).map(item => item.id) : chosenImages};
    const videoList = pinned ? allVideos : videos;
    // r6 fix: defined before first use (it was declared below and threw "Cannot access posterSet before initialization" on every
    // homepage visit that picked a non-default film, which left the collage un-initialised: no tap-to-front).
    const posterSet = url => /^(\/\/|https?:\/\/)[^/]*(\/cdn\/shop\/|cdn\.shopify\.com\/s\/files\/)/.test(url) || url.startsWith('/cdn/shop/') ? [360, 540, 720].map(w => `${url}${url.includes('?') ? '&' : '?'}width=${w} ${w}w`).join(', ') : '';
    let selected = videoList.find(item => item.id === plan.video);
    if (video.hasAttribute('src')) {
      selected = videoList.find(item => item.video === video.dataset.llVideoSrc);
      if (!selected) return;
      plan.video = selected.id;
      if (!pinned) {
      const occupied = new Set(plan.images.filter(id => id !== selected.id));
      plan.images = plan.images.map(id => {
        if (id !== selected.id) return id;
        const next = images.find(item => item.id !== selected.id && !occupied.has(item.id));
        occupied.add(next.id); return next.id;
      });
      }
    } else {
      video.dataset.llVideoSrc = selected.video;
      video.setAttribute('aria-label', selected.title);
      video.setAttribute('width', selected.width); video.setAttribute('height', selected.height);
      poster.classList.remove('ll-hero-poster-unavailable');
      poster.alt = selected.alt; poster.width = selected.width; poster.height = selected.height;
      const posterURL = new URL(selected.poster, document.baseURI).href;
      // Perf 2026-10-11: the hero poster is served at sized CDN widths (srcset); a swapped poster gets the same treatment, and the
      // hidden <video> only takes a poster when it already had one (limitless-video.js sets it before playback).
      if (poster.src !== posterURL) { poster.removeAttribute('srcset'); poster.src = selected.poster; const set = posterSet(selected.poster); if (set && poster.sizes) poster.srcset = set; }
      if (video.hasAttribute('poster') && video.poster !== posterURL) video.poster = selected.poster;
      if (button) button.dataset.playLabel = `${data.labels?.play || 'Play video'}: ${selected.title}`;
      if (button) button.dataset.pauseLabel = `${data.labels?.pause || 'Pause video'}: ${selected.title}`;
      button?.setAttribute('aria-label', button.dataset.playLabel);
      if (fallback) fallback.href = selected.video;
      const frame = video.closest('[data-ll-video]');
      frame.style.setProperty('--ll-video-aspect', `${selected.width} / ${selected.height}`);
      frame.style.maxWidth = `${selected.width}px`; frame.style.maxHeight = `${selected.height}px`;
    }
    film.dataset.llHeroProject = selected.id;
    film.dataset.llHeroCaseLink = selected.caseLink;
    film.dataset.llHeroTitle = selected.title;
    pagePlans.set(key, plan); remember(key, plan);
    const controller = new AbortController(), options = {signal:controller.signal};
    const state = {controller, plan, disposed:false, failed:new Set()};
    controllers.set(root, state);
    const applyImage = (slot, item) => {
      const image = slot.querySelector('img');
      slot.href = item.caseLink;
      slot.setAttribute('aria-label', `${item.title}: view project`);
      slot.dataset.llHeroProject = item.id;
      slot.dataset.llHeroKind = item.kind || 'image';
      slot.dataset.llHeroImageState = 'loading';
      image.alt = item.alt; image.width = item.width; image.height = item.height;
      slot.style.setProperty('--ll-hero-width-factor', Math.min(1, item.width / item.height));
      image.hidden = false;
      // r6: keep the server-rendered picture when it is already the same file (no second download)
      const next = new URL(sized(item.image, slot), document.baseURI).href;
      if (image.currentSrc !== next && image.src !== next) { image.removeAttribute('srcset'); image.src = next; }
      else if (image.complete && image.naturalWidth) slot.dataset.llHeroImageState = 'ready';
    };
    // perf 2026-10-11: the tiles are ~150-400 CSS px wide but were loading the full 1200px originals (up to 590 KB each on a phone).
    // Ask the Shopify CDN for a width that covers the tile at this screen density; the original stays the fallback on error.
    const sized = (url, slot) => {
      try {
        const u = new URL(url, document.baseURI);
        if (!/\/cdn\/shop\//.test(u.pathname) || u.searchParams.has('width')) return url;
        const css = Math.max(slot.getBoundingClientRect().width, slot.clientWidth || 0, 160);
        const need = css * Math.min(window.devicePixelRatio || 1, 2.5);
        const w = [360, 540, 720, 960, 1200].find(x => x >= need) || 1200;
        if (w >= 1200) return url;
        u.searchParams.set('width', w); return u.href;
      } catch { return url; }
    };
    slots.forEach((slot, index) => {
      const image = slot.querySelector('img');
      image.addEventListener('load', () => { slot.dataset.llHeroImageState = 'ready'; }, options);
      image.addEventListener('error', () => {
        if (state.disposed) return;
        const item = (slotItems && slotItems[index] && slotItems[index].id === plan.images[index]) ? slotItems[index] : images.find(x => x.id === plan.images[index]);
        if (item && image.src.includes('width=') && image.dataset.llFull !== item.id) { image.dataset.llFull = item.id; image.src = item.image; return; }
        state.failed.add(plan.images[index]);
        const available = projects ? projects.heroPool(images, 'image') : images;
        const next = available.find(item => item.id !== plan.video && !plan.images.includes(item.id) && !state.failed.has(item.id));
        if (next) {
          plan.images[index] = next.id; remember(key, plan); applyImage(slot, next);
        } else {
          image.hidden = true;
          slot.dataset.llHeroImageState = 'unavailable';
        }
      }, options);
      applyImage(slot, slotItems ? slotItems[index] : images.find(item => item.id === plan.images[index]));
    });
    let posterRetried = false;
    poster.addEventListener('load', () => { poster.classList.remove('ll-hero-poster-unavailable'); }, options);
    poster.addEventListener('error', () => {
      if (poster.hasAttribute('srcset')) { poster.removeAttribute('srcset'); return; } // sized variant failed: retry the original file
      const cover = allImages.find(item => item.id === selected.id);
      if (cover && !posterRetried) {
        posterRetried = true; poster.alt = cover.alt; poster.src = cover.image; video.poster = cover.image;
      } else {
        poster.classList.add('ll-hero-poster-unavailable'); video.removeAttribute('poster');
      }
    }, options);
    root.dataset.llHeroMediaState = 'ready';
  };
  const init = (scope = document) => {
    const roots = [...(scope.matches?.('[data-ll-hero-media]') ? [scope] : []), ...scope.querySelectorAll('[data-ll-hero-media]')];
    roots.forEach(prepare);
  };
  const destroy = scope => {
    controllers.forEach((state, root) => {
      if (scope === document || scope === root || scope.contains(root)) {
        state.disposed = true; state.controller.abort(); controllers.delete(root);
      }
    });
  };
  const avoid = id => {
    [...controllers.keys()].forEach(root => {
      const film = root.querySelector('[data-ll-hero-film]');
      if (film?.dataset.llHeroProject !== id) return;
      let data;
      try { data = JSON.parse(root.querySelector('[data-ll-hero-media-data]').textContent); } catch (_) { return; }
      const pool = unique(data.videos, 'video');
      const available = window.LimitlessHomeProjects ? window.LimitlessHomeProjects.heroPool(pool, 'video') : pool;
      if (!available.some(item => item.id !== id)) return;
      window.LimitlessVideo?.destroy(film);
      const video = film.querySelector('video');
      if (video.hasAttribute('src')) { video.pause(); video.removeAttribute('src'); video.load(); }
      destroy(root);
      const replacement = film.cloneNode(true);
      film.replaceWith(replacement);
      root.dataset.llHeroAvoidProject = id;
      prepare(root);
      delete root.dataset.llHeroAvoidProject;
      window.LimitlessVideo?.init(replacement);
    });
  };
  window.LimitlessHeroMedia = {init, destroy, avoid};
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => destroy(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true}); else init();
})();
